export default __webpack_public_path__ + "static/media/aud.22d5e539.svg";